import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './index.css';

// AuthProvider lives inside App.js — no need to wrap again here
ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
